import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthGuard } from '@/guards';
import Sidebar from '@/components/Sidebar';
import DashboardTopbar from '@/components/dashboard/DashboardTopbar';
import { ChatArea } from '@/components/chat';
import { useChatContext } from '@/contexts/ChatContext';

export default function ChatPage() {
  const { chatId, projectId } = useParams<{ chatId: string; projectId?: string }>();
  const { selectChat, projects, standaloneChats } = useChatContext();

  useEffect(() => {
    if (chatId) {
      // Use projectId from URL if available, otherwise try to find it from local state
      let effectiveProjectId: string | undefined = projectId;
      
      if (!effectiveProjectId) {
        // Try to find projectId from local state
        for (const project of projects) {
          if (project.chats.some((c) => c.id === chatId)) {
            effectiveProjectId = project.id;
            break;
          }
        }
        // If not found in projects, check if it's a standalone chat
        if (!effectiveProjectId) {
          const standaloneChat = standaloneChats.find((c) => c.id === chatId);
          if (standaloneChat?.projectId) {
            effectiveProjectId = standaloneChat.projectId;
          }
        }
      }
      
      void selectChat(chatId, effectiveProjectId);
    }
  }, [chatId, projectId, selectChat, projects, standaloneChats]);

  return (
    <AuthGuard>
      <div className="flex h-screen overflow-hidden bg-[color:var(--nt-bg)] text-[color:var(--nt-text)]">
        <div className="flex-shrink-0">
          <Sidebar />
        </div>
        <div className="flex-1 min-w-0 flex flex-col overflow-hidden">
          <DashboardTopbar />
          <div className="flex-1 min-h-0 overflow-hidden">
            <ChatArea />
          </div>
        </div>
      </div>
    </AuthGuard>
  );
}
